export default __webpack_public_path__ + "static/media/indigo-scales-icon.340e49a2.png";